import { __assign, __rest } from "tslib";
import React from 'react';
// Default provider options
var providerDefaults = {
    ripple: true,
    tooltip: {
        align: 'top',
        showArrow: false,
        activateOn: ['hover', 'focus'],
        enterDelay: 0,
        leaveDelay: 0
    },
    typography: {},
    icon: {
        icon: '',
        basename: 'material-icons',
        prefix: '',
        strategy: 'auto',
        render: undefined
    }
};
export var ProviderContext = React.createContext(providerDefaults);
export var useProviderContext = function () { return React.useContext(ProviderContext); };
/** A provider for setting global options in RMWC. */
export var RMWCProvider = function (_a) {
    var children = _a.children, rest = __rest(_a, ["children"]);
    return (React.createElement(ProviderContext.Provider, { value: __assign(__assign({}, providerDefaults), rest) }, children));
};
